import React from 'react';

import UniqueId from '../../../services/uid/UniqueId';

import DictionaryDialogContainer from './DictionaryDialogContainer';

interface Props {
  ids: UniqueId[];
}

const ActiveDictionaries: React.FC<Props> = ({ ids }) => (
  <>
    {ids.map(id => (
      <DictionaryDialogContainer key={id} id={id} open={true} />
    ))}
  </>
);

export default ActiveDictionaries;
